import React from 'react';
import { Description, Image, SubTitle } from '../../components/layouts';
import { buildImageURL, getTrack } from '../../helpers';
import './style.scss';

const IMAGE = buildImageURL('/camera-backlight.png')

const track = getTrack({ block: 9 });

export function CameraNight2({ mobile = false }) {
  return (
    <div className="page-section section-camera-night-backlight inverted" data-track={track}>
      <div className="section-content center">
        <div className="txt-wrapper">
          <SubTitle>
            超逆光夜景人像
          </SubTitle>
          <Description>
            你的美，不分昼夜。黑夜C位非你莫属。等效50mm专业人像镜头搭配夜景
            <br/>
            优化，让你的美在黑夜中也能轻松被聚焦。
          </Description>
        </div>
        <Image src={IMAGE} className="img-backlight" />
      </div>
    </div>
  );
}
